'use strict';

import angular from 'angular';
import servicesModule from '../services';

const currencyResourceFactory = ($http, utils) => {
  'ngInject';

  return {
    saveCurrency: (userId, value) => {
      const url = utils.getApiUrlV2(`/users/${userId}/currency`);
      const postData = {
        currency: value
      };

      return $http.post(url, postData);
    }
  };
};

const dependencies = [
  servicesModule
];

export default angular
  .module('resources.currencyResource', dependencies)
  .factory('currencyResource', currencyResourceFactory)
  .name;



// WEBPACK FOOTER //
// ./app/src/resources/currency_resource.service.js